import { useState } from "react";
import { Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";
export default function City({ data, editedDataHandler, spLoader }) {
    const [formData, setFormData] = useState({
        country: data.country == null ? "" : data.country,
        province: data.province == null ? "" : data.province,
        city: data.city == null ? "" : data.city,
        neighbourhood: data.neighbourhood == null ? "" : data.neighbourhood,
        address: data.address == null ? "" : data.address,
    });
    const { t } = useTranslation();

    const onChangeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [errors, setErrors] = useState({
        countryErr: "",
        provinceErr: "",
        cityErr: "",
        neighbourhoodErr: "",
        addressErr: "",
    });

    const handleFormErr = () => {
        let countryErr = "";
        let provinceErr = "";
        let cityErr = "";
        let neighbourhoodErr = "";
        let addressErr = "";

        if (formData.country === "" || formData.country === null) {
            countryErr = t("Src.Pages.UserPages.UserProfile.City.countryErr");
        }
        if (formData.province === "" || formData.province === null) {
            provinceErr = t("Src.Pages.UserPages.UserProfile.City.provinceErr");
        }
        if (formData.city === "" || formData.city === null) {
            cityErr = t("Src.Pages.UserPages.UserProfile.City.cityErr");
        }
        if (formData.neighbourhood === "" || formData.neighbourhood === null) {
            neighbourhoodErr = t(
                "Src.Pages.UserPages.UserProfile.City.neighbourhoodErr"
            );
        }
        if (formData.address === "" || formData.address === null) {
            addressErr = t("Src.Pages.UserPages.UserProfile.City.addressErr");
        }

        setErrors({
            ...errors,
            countryErr,
            provinceErr,
            cityErr,
            neighbourhoodErr,
            addressErr,
        });

        if (
            provinceErr === "" &&
            countryErr === "" &&
            cityErr === "" &&
            neighbourhoodErr === "" &&
            addressErr === ""
        ) {
            return true;
        }

        return false;
    };

    const sendData = (e) => {
        e.preventDefault();

        let noErr = handleFormErr();

        if (!noErr) return false;

        editedDataHandler(e, formData);
    };

    return (
        <div className="page-load-fade">
            <form className="general-info-form">
                <Form.Group controlId="counry">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.LivingPlaceInfo.Country.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.country}
                        name="country"
                        onChange={onChangeHandler}
                        className={errors.countryErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.countryErr ? "block" : "none",
                        }}
                    >
                        {errors.countryErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="povince">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.LivingPlaceInfo.Province.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.province}
                        name="province"
                        onChange={onChangeHandler}
                        className={errors.provinceErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.provinceErr ? "block" : "none",
                        }}
                    >
                        {errors.provinceErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="city">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.LivingPlaceInfo.City.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.city}
                        name="city"
                        onChange={onChangeHandler}
                        className={errors.cityErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.cityErr ? "block" : "none",
                        }}
                    >
                        {errors.cityErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="allay">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.LivingPlaceInfo.District.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.neighbourhood}
                        name="neighbourhood"
                        onChange={onChangeHandler}
                        className={errors.neighbourhoodErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.neighbourhoodErr ? "block" : "none",
                        }}
                    >
                        {errors.neighbourhoodErr}
                    </div>
                </Form.Group>

                <Form.Group controlId="address">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.LivingPlaceInfo.Address.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        value={formData.address}
                        name="address"
                        onChange={onChangeHandler}
                        className={errors.addressErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.addressErr ? "block" : "none",
                        }}
                    >
                        {errors.addressErr}
                    </div>
                </Form.Group>

                <Form.Group></Form.Group>

                <div className="btn-group">
                    <button onClick={sendData} className=" blue loader-bt">
                        {spLoader ? (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        ) : (
                            <>
                                {t(
                                    "UserPanel.Profile.LivingPlaceInfo.SaveChanges.Button"
                                )}
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}
